<template>
  <v-timeline-item
    fill-dot
    dot-color="background-active"
  >
    <template #icon>
      <v-icon
        tag="span"
        class="text-primary"
      >
        mdi-message-text
      </v-icon>
    </template>
    <v-card
      :class="{'large-comment-bubble': mdAndUp, 'background-active': true}"
      :color="`${commentColor}-lighten-4`"
    >
      <v-card-text class="pb-1 pt-2">
        <p class="text-h5">
          {{ senderName }}
        </p>
        <p>
          {{ m(comment.date, `${$t("communicationPanelStrings.eventDateTimeDisplayFormat")}`) }}<br>
          <template v-if="recipients.length">
            <em>{{ recipients }}</em><br>
          </template>
          {{ comment.content }}
        </p>
      </v-card-text>
    </v-card>
  </v-timeline-item>
</template>

<script>
import { mapGetters } from "vuex";
import { getOrgName, getPersonName } from "@/utils/currentApplication";
import { useDisplay } from 'vuetify';
import { m } from '@/plugins/moment';

export default {
  name: "LogComment",
  props: {
    comment: {
      type: Object,
      required: true
    },
    ownComment: {
      type: Boolean
    }
  },
  setup() {
    const { mdAndUp } = useDisplay();
    return { mdAndUp, m };
  },
  computed: {
    commentColor() {
      if (this.ownComment) {
        return "primary";
      }

      return "grey";
    },
    ...mapGetters({
      payingOrgs: "application/payingOrgsStore/payingOrgs"
    }),
    senderName() {
      const personName = getPersonName(this.comment.sender.personId);

      if (this.comment.sender.orgId) {
        const orgName = getOrgName(this.comment.sender.orgId);

        if (orgName) {
          return `${orgName} (${personName})`;
        }
      }

      return personName;
    },
    recipients() {
      if (this.comment.recipients.length === 0) {
        return "";
      }

      return `${this.$t(
        "communicationPanelStrings.to"
      )} ${this.comment.recipients.map(orgId => getOrgName(orgId)).join(", ")}`;
    }
  },
  methods: {
    isOwnComment(comment) {
      if (this.commentAsReceiver) {
        return comment.sender.orgId === this.currentOrgId;
      }

      return comment.sender.personId === this.currentPersonId;
    }
  }
};
</script>